import { Meal } from './Meal'

export class MealRequestDTO {

    meal : Meal

    constructor(meal : Meal) {
        this.meal = meal
    }

}